import React from 'react';


import { motion, AnimatePresence } from 'framer-motion';

const MenuDetails = ({ menu }) => {
    if (!menu) return null;
  return (
    <div className="w-2/3 menu-detail">
      <AnimatePresence exitBeforeEnter id="menu-detail-container">
        <motion.div
            id="menu-detail"
            key={menu.id}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            // className="p-6 bg-white shadow-lg rounded-lg menu-detail-container "
        >
          <div className='detaildisplaygd'>
            <div><img src={menu.image_url} alt={menu.name} /* className="w-full h-48 object-cover rounded-lg mb-4" *//></div>
            <div className='detaildisplaygdtext'>
              <h2 className="text-xl font-semibold">{menu.name}</h2>
              <p className="text-gray-600">{menu.description}</p>
              <p className="text-lg font-bold mt-2">{menu.price}€</p>
            </div>
          </div>
          
          
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default MenuDetails;
